import { Component } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.css']
})
export class GlobalLoaderComponent {
  isLoading = false
  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading.subscribe(res => {
      this.isLoading = res
      console.log(res);
      
    })
  }


}
